import { createSlice } from "@reduxjs/toolkit";
import {
  fetchIndirectExpenseLedger,
  fetchIndirectExpenseAccountsBySearch,
} from "./IndirectExpenseLedgerThunk";

const initialState = {
  list: [],
  indirectAccounts: [],
  indirectAccountLoading: false,
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const indirectExpenseLedgerSlice = createSlice({
  name: "indirectExpenseLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndirectExpenseLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIndirectExpenseLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchIndirectExpenseLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchIndirectExpenseAccountsBySearch.pending, (state) => {
        state.indirectAccountLoading = true;
      })
      .addCase(fetchIndirectExpenseAccountsBySearch.fulfilled, (state, action) => {
        state.indirectAccountLoading = false;
        state.indirectAccounts = action.payload;
      })
      .addCase(fetchIndirectExpenseAccountsBySearch.rejected, (state) => {
        state.indirectAccountLoading = false;
        state.indirectAccounts = [];
      });
  },
});

export const { setFilters } = indirectExpenseLedgerSlice.actions;
export default indirectExpenseLedgerSlice.reducer;
